<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog h560_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            实物资源领用单信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="单据编号">
                  <el-input
                    v-model="dialogViewForm.claimFormNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申报日期">
                  <el-date-picker
                    v-model="dialogViewForm.applyTime"
                    type="datetime"
                    style="width: 100%;"
                    format="yyyy-MM-dd HH:mm:ss"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="领用部门">
                  <el-input
                    v-model="dialogViewForm.receiveDepartment"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="领用人">
                  <el-input
                    v-model="dialogViewForm.receiver"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="方案编号">
                  <el-input
                    v-model="dialogViewForm.schemeNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="方案名称">
                  <el-input
                    v-model="dialogViewForm.schemeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动场景">
                  <el-input
                    v-model="dialogViewForm.activityScenario"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="使用用途">
                  <el-input
                    v-model="dialogViewForm.purpose"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="物料编码">
                  <el-input
                    v-model="dialogViewForm.materialCode"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物料名称">
                  <el-input
                    v-model="dialogViewForm.materialName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="方案数量">
                  <el-input
                    v-model="dialogViewForm.schemeNumber"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="本次申领数量">
                  <el-input
                    v-model="dialogViewForm.applyNumber"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="单价">
                  <el-input
                    v-model="dialogViewForm.price"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="金额(元)">
                  <el-input
                    v-model="dialogViewForm.amount"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="审核人">
                  <el-input
                    v-model="dialogViewForm.auditor"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核时间">
                  <el-date-picker
                    v-model="dialogViewForm.auditTime"
                    type="datetime"
                    style="width: 100%;"
                    format="yyyy-MM-dd HH:mm:ss"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="出库人">
                  <el-input
                    v-model="dialogViewForm.outboundOperator"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="出库时间">
                  <el-date-picker
                    v-model="dialogViewForm.outboundTime"
                    type="datetime"
                    style="width: 100%;"
                    format="yyyy-MM-dd HH:mm:ss"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="创建人">
                  <el-input
                    v-model="dialogViewForm.creatorName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="dialogViewForm.createTime"
                    type="datetime"
                    style="width: 100%;"
                    format="yyyy-MM-dd HH:mm:ss"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="操作人">
                  <el-input
                    v-model="dialogViewForm.operatorName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="操作时间">
                  <el-date-picker
                    v-model="dialogViewForm.operationTime"
                    type="datetime"
                    style="width: 100%;"
                    format="yyyy-MM-dd HH:mm:ss"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { viewPhysicalResourcesClaimFormApi } from '@/api/v2/physicalResourcesClaimForm'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.dialogViewForm = {};
        _this.initViewData();
      }
    }
  },
  methods: {
    // 加载数据
    initViewData () {
      let _this = this;
      viewPhysicalResourcesClaimFormApi({ id: _this.dataId }).then(response => {
        const { data } = response
        _this.dialogViewForm = data || {};
      })
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
